const KEYS = {
  LOGIN_USER: 'LUT',
  LOGIN_TOKEN: 'LUT_TK',
  ADMIN_TOKEN: 'AT',
  LANG: 'LANG',

  RESULT_IDX: 'RI',
  SURVEY_IDX: 'SI',

  SCHOOL_NAME: 'SN',
  SCHOOL_YEAR: 'SY',
  NAME: 'NAME',
};
export { KEYS };
